<template>
	<Page ref="element">
		<div class="header">
			<img :src="crystal" class="crystal" />
			<div class="coins-wrapper">
				<img class="coins-icon" :src="crystal" />
				{{ user?.coins.toLocaleString() }}
			</div>
			<DailyGift />
		</div>

		<TaskCard v-for="task in taskList" :key="task._id" :task="task" />
	</Page>
</template>

<script setup lang="ts">
import Page from '@/components/ui/Page.vue';
import DailyGift from '@/features/tasks/components/DailyGift.vue';
import TaskCard from '@/features/tasks/components/TaskCard.vue';
import { useTaskList } from '@/features/tasks/hooks/useTask';
import { useUser } from '@/features/tasks/hooks/useUser';
import crystal from '@/assets/images/crystal.png';
import BaseTypography from '@/components/ui/BaseTypography.vue';

const { data: taskList } = useTaskList();
const { data: user } = useUser();
</script>

<style scoped>
.header {
	z-index: 10;
	display: flex;
	flex-direction: column;
}

.crystal {
	width: 35%;

	transform: rotate(14.93deg);

	margin: 2em auto 0em auto;

	filter: drop-shadow(0px 0px 50px rgba(0, 132, 255, 0.52));
}

@keyframes fadeOut {
	from {
		opacity: 1;
	}
	to {
		opacity: 0;
	}
}

.coins-wrapper {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: baseline;
	gap: 12px;

	border-radius: 16px;

	padding: 16px 32px;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 800;
	font-size: 40px;
	line-height: 48px;

	text-align: center;

	color: #ffffff;
}

.coins-icon {
	width: 25.14px;
	height: 29.41px;

	filter: drop-shadow(0px 0px 50px rgba(0, 132, 255, 0.52));
	transform: rotate(0.94deg);
}

.task-list {
	overflow: scroll;
}
</style>
